export const RACQUET_BRANDS = [
  'Babolat',
  'Head',
  'Prince',
  'Tecnifibre',
  'Wilson',
  'Yonex',
];

export const RACQUET_MODELS: Record<string, string[]> = {
  Babolat: ['Pure Aero', 'Pure Drive', 'Pure Strike', 'Boost Aero', 'Boost Drive'],
  Head: ['Speed', 'Radical', 'Extreme', 'Gravity', 'Boom', 'Prestige'],
  Prince: ['Textreme Tour', 'Phantom', 'Beast', 'Ripstick'],
  Tecnifibre: ['T-Fight', 'T-Rebound', 'TF-X1', 'Tempo'],
  Wilson: ['Pro Staff', 'Blade', 'Clash', 'Ultra', 'Burn', 'Shift'],
  Yonex: ['EZONE', 'VCORE', 'Percept', 'Astrel'],
};

export const GRIP_SIZES = ['4', '4 1/8', '4 1/4', '4 3/8', '4 1/2', '4 5/8', '4 3/4'];

export const STRING_BRANDS = [
  'Babolat',
  'Head',
  'Luxilon',
  'Solinco',
  'Tecnifibre',
  'Wilson',
  'Yonex',
];

export const STRING_TYPES = [
  'Polyester',
  'Multifilament',
  'Synthetic Gut',
  'Natural Gut',
  'Hybrid (Poly/Gut)',
  'Hybrid (Poly/Multi)',
];

export const STRING_TENSIONS = [
  '40 lbs',
  '42 lbs',
  '44 lbs',
  '46 lbs',
  '48 lbs',
  '50 lbs',
  '52 lbs',
  '54 lbs',
  '56 lbs',
  '58 lbs',
  '60 lbs',
  '62 lbs',
];

export const SHOE_BRANDS = [
  'Adidas',
  'Asics',
  'Babolat',
  'Head',
  'K-Swiss',
  'New Balance',
  'Nike',
  'Wilson',
];

export const SHOE_MODELS: Record<string, string[]> = {
  Adidas: ['Barricade', 'Adizero Ubersonic', 'GameCourt', 'CourtJam'],
  Asics: ['Gel Resolution', 'Gel Game', 'Court FF', 'Solution Speed'],
  Babolat: ['Jet Mach', 'Jet Tere', 'Propulse', 'SFX3'],
  Head: ['Sprint Pro', 'Revolt Pro', 'Sprint Team'],
  'K-Swiss': ['Hypercourt Express', 'Ultrashot', 'SpeedTrac'],
  'New Balance': ['Fresh Foam Lav', '996', 'FuelCell 996'],
  Nike: ['Air Zoom Vapor Pro', 'Air Zoom Vapor 11', 'Court Air Zoom NXT', 'Court Lite'],
  Wilson: ['Rush Pro', 'Kaos', 'Hurakn'],
};

export const SHOE_SIZES = [
  '1 US', '1.5 US', '2 US', '2.5 US', '3 US', '3.5 US',
  '4 US', '4.5 US', '5 US', '5.5 US', '6 US', '6.5 US',
  '7 US', '7.5 US', '8 US', '8.5 US', '9 US', '9.5 US',
  '10 US', '10.5 US', '11 US', '11.5 US', '12 US', '12.5 US',
  '13 US', '13.5 US', '14 US',
];

export const PLAYING_STYLES = [
  { value: 'baseline', label: 'Baseliner' },
  { value: 'serve_and_volley', label: 'Serve & Volley' },
  { value: 'all_court', label: 'All-Court' },
  { value: 'aggressive_baseliner', label: 'Aggressive Baseliner' },
];

export const DOMINANT_HANDS = [
  { value: 'right', label: 'Right' },
  { value: 'left', label: 'Left' },
  { value: 'ambidextrous', label: 'Ambidextrous' },
];

export const BACKHAND_TYPES = [
  { value: 'one_handed', label: 'One-Handed' },
  { value: 'two_handed', label: 'Two-Handed' },
];
